module.exports = __webpack_public_path__ + "static/img/s-mi-2.70c2bff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-mi-2.png
// module id = hC65
// module chunks = 1